import ReportPoPembelian from '@/models/ReportPoPembelian/ReportPoPembelian';

export default class ReportPoPembelianFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterVendor = '';
		this.filterPart = '';
		this.filterPoNumber = '';
		this.filterPoDateFrom = '';
		this.filterPoDateTo = '';
		this.filterCustomer = '';
		this.filterPartSpecification = '';
		this.filterStatusDelivery = '';
		this.tempId = '';
		this.supplierCode = '';
		this.customerCode = '';
		this.partNumber = '';
		this.partSpecification = '';
		this.purchaseOrderNumber = '';
		this.qtyPo = '';
		this.qtyActual = '';
		this.balance = '';
		this.uom = '';
		this.statusDelivery = '';
		this.purchaseOrderDateFrom = '';
		this.purchaseOrderDateTo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterVendor : '0',
			filterPart : '0',
			filterPoNumber : '0',
			filterPoDateFrom : '0',
			filterPoDateTo : '0',
			filterCustomer : '0',
			filterPartSpecification : '0',
			filterStatusDelivery : '0',
			tempId : '0',
			supplierCode : '0',
			customerCode : '0',
			partNumber : '0',
			partSpecification : '0',
			purchaseOrderNumber : '0',
			qtyPo : '0',
			qtyActual : '0',
			balance : '0',
			uom : '0',
			statusDelivery : '0',
			purchaseOrderDateFrom : '0',
			purchaseOrderDateTo : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}